import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';
import moment from 'moment';

import { Modal, message, Tag } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function () {

    }
}

const headers = utils.columns([
    { key: '$index', label: '序号', width: 60 },
    { key: 'orgName', label: '部门', width: 100 },
    { key: 'userCode', label: '教师工号', width: 100 },
    { key: 'userName', label: '教师', width: 100 },
    { key: 'courseName', label: '课程名称', width: 150 },
    {key:'auditState1', label: '系部教学科审核', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>预提交</Tag>)},
    { key: 'auditUserName1', label: '系教学科审核人', width: 120 },
    {key:'auditState2', label: '系部主任审核', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>预提交</Tag>)},
    { key: 'auditUserName2', label: '系主任审核人', width: 120 },
    {key:'auditState3', label: '发规处审核', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>预提交</Tag>)},
    { key: 'auditUserName3', label: '发规处审核人', width: 120 },
    { key: 'termName', label: '学期名称', width: 120 },
    { key: 'createTime', label: '报名日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
]);



/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('graduation/form/result/get/' + id, {})
        .then(response => response.payload.data)
        .catch(error => {
        });
}


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('graduation/form/result/query', Object.assign(defaultsParams, keywords))
        .then(response => {
            // let paramValue = response.payload.meta.extParams.paramValue || ",";
            // if (paramValue && paramValue.startsWith("[")) {
            //     paramValue = paramValue.slice(1, paramValue.length); // 去掉首尾括号
            // }
            // if (paramValue && paramValue.endsWith("]")) {
            //     paramValue = paramValue.slice(0, -1); // 去掉首尾括号
            // }
            // const paramValueArray = paramValue.split(',');

            // const columns = [
            //     { key: '$index', label: '序号', width: 75 },
            // ];
            // if (paramValueArray.includes('orgName')) {
            //     columns.push(
            //         { key: 'orgName', label: '开课学院', width: 150 },
            //     )
            // }
            // if (paramValueArray.includes('courseName')) {
            //     columns.push(
            //         { key: 'courseName', label: '课程名称', width: 150 },
            //     )
            // }
            // if (paramValueArray.includes('employeeCode')) {
            //     columns.push(
            //         { key: 'employeeCode', label: '教师工号', width: 100 },
            //     )
            // }
            // if (paramValueArray.includes('employeeName')) {
            //     columns.push(
            //         { key: 'employeeName', label: '教师', width: 100 },
            //     )
            // }
            // if (paramValueArray.includes('classTime')) {
            //     columns.push(
            //         { key: 'classTime', label: '开课时间', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
            //     )
            // }
            // if (paramValueArray.includes('lessonAddress')) {
            //     columns.push(
            //         { key: 'lessonAddress', label: '教室', width: 150 },
            //     )
            // }
            // if (paramValueArray.includes('classGrade')) {
            //     columns.push(
            //         { key: 'classGrade', label: '年级', width: 100 },
            //     )
            // }
            // if (paramValueArray.includes('weekNumBg')) {
            //     columns.push(
            //         { key: 'weekNumBg', label: '开始周', width: 80 },
            //     )
            // }
            // if (paramValueArray.includes('weekNumEnd')) {
            //     columns.push(
            //         { key: 'weekNumEnd', label: '结束周', width: 80 },
            //     )
            // }
            // if (paramValueArray.includes('classWeek')) {
            //     columns.push(
            //         { key: 'classWeek', label: '听课周次', width: 80, render: (value) => value ? `第${value}周` : "" },
            //     )
            // }
            // if (paramValueArray.includes('deadline')) {
            //     columns.push(
            //         { key: 'deadline', label: '选课截止日期', width: 120, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
            //     )
            // }
            // columns.push({ key: 'selectionNum', label: '被选次数', width: 120 })
            // columns.push(
            //     {
            //         key: 'submitState', label: '提交状态', width: 80, render: (value) => {
            //             if (value === '1') return "预提交";
            //             else if (value === '2') return "正式提交";
            //             else return "";
            //         }
            //     });
            // columns.push(
            //     {
            //         key: 'submitSituation', label: '提交情况', width: 80, render: (value) => {
            //             if (value === 1) return <span style={{ marginLeft: '2px' }}>
            //                 <i class="fa fa-circle" aria-hidden="true" style={{ color: '#31b431' }}></i>
            //             </span>;
            //             else return <span style={{ marginLeft: '2px' }}>
            //                 <i class="fa fa-circle" aria-hidden="true" style={{ color: '#f5222d' }}></i>
            //             </span>;
            //         }
            //     });
            return {
                // headers: utils.columns(columns),
                headers: headers,
                data: response.payload.data,
            };
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}


/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const save = (data) => {
    return fetch.post('graduation/form/result/save', data)
}

const submit = (data) => {
    return fetch.post('graduation/form/result/submit', data)
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('graduation/form/result/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback, setLoading) => {
    return new Promise(function (resolve, reject) {
        if (DataGrid.selections.length === 0) {
            Modal.error({
                title: '请先选择一项或多项！',
                content: '只有勾选一项或多项后才能删除！',
            });
        } else {
            Modal.confirm({
                title: '确定删除该记录？',
                content: '删除后将无法恢复！',
                onOk() {
                    setLoading ? setLoading(true) : "";
                    remove(DataGrid.selections).then(response => {
                        if (response.code === 200) {
                            if (response.payload.data.fail === 0) {
                                message.success(response.message);
                            } else {
                                message.warn("删除操作： 成功" + response.payload.data.success + "个;失败" + response.payload.data.fail + "个\n"
                                    + "存在已测评的记录，请删除测评结果后再进行删除！"
                                )
                            }

                            resolve();
                            DataGrid.selections = [];
                            callback();
                        } else {
                            reject();
                        }
                    });
                },
                onCancel() { },
                okText: "确认",
                cancelText: "取消"
            });
        }
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const getSelectionData = () => {
    return DataGrid.selectData;
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
const exportList = (keywords) => {
    return fetch.download('graduation/form/result/export', keywords, "课堂认证信息数据导出.xls")
}

/**
 * @method fallback
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const fallback = (ids) => {
    return fetch.post('graduation/form/result/fallback', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

const getForInput  = (id) => {
    return fetch.get(`graduation/form/result/getForInput/`+id).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const removeByIds = (ids) => {
    return fetch.post(`graduation/form/result/deleteByIds`, ids).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}


/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    return fetch.post('graduation/form/result/batch/back', {ids: DataGrid.selections})
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

/**
 * @method batchSubmit
 * @return {promise}
 */
const batchSubmit = (callback) => {
    return fetch.post('graduation/form/result/batch/submit', {ids: DataGrid.selections})
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

export default {
    querySearchById,
    save,
    submit,
    querySearch,
    remove,
    headers,
    onSelect,
    onSelectData,
    batchRemove,
    setRefresh,
    getSelection,
    getSelectionData,
    exportList,
    fallback,
    getForInput,
    removeByIds,
    batchBack,
    batchSubmit
}